import React from "react";
import { Box, Tabs, Tab } from "@mui/material";

export default function AnalyticsTabs({ 
  activeTab, 
  handleTabChange, 
  allTabs 
}) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="fullWidth"
        scrollButtons="auto"
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{
          "& .MuiTab-root": {
            minWidth: 120,
            fontWeight: "bold",
            textTransform: "none",
            fontSize: "14px",
            position: "relative",
            color: "#000",
          },
          "& .Mui-selected": {
            backgroundColor: "#03A9F4",
            color: "#fff !important",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
          },
        }}
      >
        {allTabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            id={`analytics-tab-${index}`}
            aria-controls={`analytics-tabpanel-${index}`}
          />
        ))}
      </Tabs>
    </Box>
  );
}